import { createSelector } from 'reselect';

import getCurrentOrder from './getCurrentOrder';

export const getCurrentSavedCard = createSelector(
  [getCurrentOrder],
  order => order.currentSavedCard,
);
